let containerDots = document.querySelector("slider-component .dots");
let thumbs = document.querySelectorAll(".custom-div img");
let sliderContainer = document.querySelector('.gallery-variants .product__media-wrapper slider-component');

if(sliderContainer) {
// Create unordered list
  let dotList = document.createElement("ul");
  thumbs.forEach(function (item, index) {
    // Create list item
    let dotListItem = document.createElement("li");
    // Add event listener (optional)
    // dotListItem.addEventListener('click', function() {
    //   // Handle click event to navigate slider
    // });
    // Append list item to unordered list
    dotList.appendChild(dotListItem);
    item.addEventListener("click", function (e) {
      let dots = document.querySelectorAll("slider-component .dots ul li");
      dots.forEach(function (e) {
        e.classList.remove("active");
      });
      dots[index].classList.add("active");
    });
  });

  // Add unordered list to container (if needed)
  containerDots.appendChild(dotList);

  let dots = document.querySelectorAll("slider-component .dots ul li");
    dots[0].classList.add('active');

    dots.forEach(function (e, i) {
      e.addEventListener("click", function () {
        this.classList.add("active");
        thumbs[i].click();
      });
    });


  setTimeout(() => {
    let variants = document.querySelectorAll(
      ".product-form__input input[type=radio]+label.color-swatch"
    );
    variants.forEach(function (v) {
      v.addEventListener("click", function () {
        sliderContainer.style.opacity="0"
        let container = document.querySelector("slider-component .dots ul");
        container.innerHTML = "";
        setTimeout(() => {
          let thumbs = document.querySelectorAll(".custom-div img");
        
          thumbs.forEach(function (item, index) {
            const listItem = document.createElement("li");

            container.appendChild(listItem);

            item.addEventListener("click", function (e) {
              let dots = document.querySelectorAll(
                "slider-component .dots ul li"
              );
              dots.forEach(function (e) {
                e.classList.remove("active");
              });
              dots[index].classList.add("active");
            });
          });
          setTimeout(() => {
            sliderContainer.style.opacity="1"
          }, 100);
        
          let dots = document.querySelectorAll("slider-component .dots ul li");
          dots[0].classList.add('active');
          thumbs[0].click()
          dots.forEach(function (e, i) {
            e.addEventListener("click", function () {
              this.classList.add("active");
              thumbs[i].click();
            });
          });
        }, 1000);
      
      });
    });
  }, 5000);


  let touchstartX = 0;
  let touchstartY = 0;
  let touchendX = 0;
  let touchendY = 0;

  const gestureZone = document.querySelector(".slider.slider--mobile");

  gestureZone.addEventListener(
    "touchstart",
    function (event) {
      touchstartX = event.changedTouches[0].screenX;
      touchstartY = event.changedTouches[0].screenY;
    },
    false
  );

  gestureZone.addEventListener(
    "touchend",
    function (event) {
      touchendX = event.changedTouches[0].screenX;
      touchendY = event.changedTouches[0].screenY;
      handleGesture();
    },
    false
  );

  function handleGesture() {
    if (touchendX < touchstartX) {
      let active = document.querySelector(".dots ul li.active");
      active.classList.remove("active");
      if (active.nextElementSibling) {
        active.nextElementSibling.click();
      } else {
        let dots = document.querySelectorAll("slider-component .dots ul li");
        dots[dots.length - 1].click();
      }
    }

    if (touchendX > touchstartX) {
      let active = document.querySelector(".dots ul li.active");
      active.classList.remove("active");
      if (active.previousElementSibling) {
        active.previousElementSibling.click();
      } else {
        let dots = document
          .querySelectorAll("slider-component .dots ul li")[0]
          .click();
      }
    }
  }

}